import { MouseEventHandler } from "react";

import MainButton from "~/components/common/mainButton";
import { useLanguage } from "~/contexts/providers/language";
import englishTranslations from "~/localization/en";
import frenchTranslations from "~/localization/fr";

import styles from "./index.module.scss";

type Props = {
  step: number;
  handleBack: MouseEventHandler<HTMLButtonElement>;
  handleNext: MouseEventHandler<HTMLButtonElement>;
};

const ApplicationNavigationButtons = ({
  step,
  handleBack,
  handleNext,
}: Props) => {
  const { language } = useLanguage();
  const applyTexts =
    language === "En"
      ? englishTranslations.applyPage
      : frenchTranslations.applyPage;
  const disabled = step == 0;

  const steps: Record<number, string> = {
    0: applyTexts.applicationForm.startApplicationButton,
    1: `${applyTexts.applicationForm.nextButton}  →`,
    2: `${applyTexts.applicationForm.nextButton}  →`,
    3: `${applyTexts.applicationForm.nextButton}  →`,
    4: `${applyTexts.applicationForm.nextButton}  →`,
    5: `${applyTexts.applicationForm.nextButton}  →`,
    6: `${applyTexts.applicationForm.nextButton}  →`,
    7: `${applyTexts.applicationForm.nextButton}  →`,
    8: "Confirmer votre candidature →",
    9: "Fermer",
  };

  return (
    <div className={styles.applicationNavigationButtons}>
      <MainButton
        onClick={handleBack}
        disabled={disabled}
        className={disabled ? styles.disabled : undefined}
      >
        ← {applyTexts.applicationForm.backButton}
      </MainButton>

      <MainButton onClick={handleNext}>{steps[step]}</MainButton>
    </div>
  );
};

export default ApplicationNavigationButtons;
